import { ENVIRONMENT_ACTION_TYPES } from './environment.types';

export const ENVIRONMENT_INITIAL_STATE = {
  isSelectorOpen: false,
  environmentList: [],
};

export const environmentReducer = (state = ENVIRONMENT_INITIAL_STATE, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case ENVIRONMENT_ACTION_TYPES.SET_ENVIRONMENT_LIST:
      return {
        ...state,
        environmentList: payload,
      };
    case ENVIRONMENT_ACTION_TYPES.SET_ENVIRONMENT_OPEN:
      return {
        ...state,
        isSelectorOpen: payload,
      };
    default:
      return state;
  }
};
